import { inject, nextTick, provide, ref } from "vue";

/**
 * @description routeをreloadさせる
 */

export function provideReloadFunc() {
  const isRouterAlive = ref(true);
  const reload = () => {
    isRouterAlive.value = false;
    nextTick(() => {
      isRouterAlive.value = true;
    });
  };
  provide("reload", reload);
  return isRouterAlive;
}

export function injectReloadFunc() {
  const reload = inject("reload") as () => void;
  return reload;
}
